


































































import { Input, Form, FormItem, Select, Option, OptionGroup } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import EmergencyContact from '@/models/emegrency-contact'

import { ProfileDataActionTypes } from '@/store/modules/profileData'

@Component({
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
  },
})
export default class EmergencyContactDetailsForm extends Vue {
  @Prop() emergencyContact!: EmergencyContact

  rules = {}

  form = {
    firstName: '',
    lastName: '',
    tel: '',
    countryCode: '',
    relationship: '',
  }

  created() {
    this.$store.dispatch(ProfileDataActionTypes.LoadCountries)

    if (this.emergencyContact) {
      this.fillInForm()
    }
  }

  get countryOptions() {
    return this.$store.getters.countries
  }

  fillInForm() {
    const { form, emergencyContact, $_ } = this
    const prefilledFields = $_.pick(
      emergencyContact,
      Object.keys(form),
    ) as EmergencyContact

    this.form = { ...form, ...prefilledFields }
  }

  onEmergencyContactUpdate(updates: { [field: string]: any }) {
    this.$emit('on-emergency-contact-update', {
      emergencyContact: updates,
    })
  }
}
